import axios from 'axios'

export default {
	data() {
		return {
			dataInfo: {
				email: 'servicio@dinerbacano.co',
				client_whats_app: '+573103062629',
			},
		}
	},
	mounted() {
		axios
			.post('https://api.dinerbacano.co/gateway/ApiService/api/v8/h5/auth/appsflyer/appStatisticsNew', {
				source: 'Dinerbacano',
			})
			.then((res) => {
				if (res.data.code == 0) {
					this.dataInfo = res.data.data
				}
			})
	},
}
